import React from 'react';
import '../assets/styles/popup.css';

export default function Popup({ popup, handleChange, player, submitPlayer, cancel }) {

  return (popup) ? (
    <div className="popup">
      <div className="popup-inner">
        <p>
          Well done! You are in the TOP 10 now!
          <br />
          Please add your name here:
        </p>
        <input
          onChange={handleChange}
          name='player'
          value={player}
          type='text'
          placeholder='name:'
          minLength={2}
          maxLength={35}
        />
        <button className="close-btn" onClick={submitPlayer}>OK</button>
        <button className='cancel-btn' onClick={cancel} >Cancel</button>
      </div>
    </div>
  ) : '';
}